import { useRef } from 'react'

/**
 * Returns a ref that always holds the latest value.
 * Safe to use inside useCallback/useEffect deps arrays without
 * triggering re-renders, since the ref object identity is stable.
 *
 * @template T
 * @param {T} value
 * @returns {import('react').MutableRefObject<T>}
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function useAutoUpdatingRef(value) {
  const ref = useRef(value)
  ref.current = value
  return ref
}
